import { render, staticRenderFns } from "./index.vue?vue&type=template&id=58de782f"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58de782f')) {
      api.createRecord('58de782f', component.options)
    } else {
      api.reload('58de782f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=58de782f", function () {
      api.rerender('58de782f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/index.vue"
export default component.exports